import { render, staticRenderFns } from "./ObjectThree.vue?vue&type=template&id=4759e9ab&lang=pug&"
import script from "./ObjectThree.vue?vue&type=script&lang=js&"
export * from "./ObjectThree.vue?vue&type=script&lang=js&"
import style0 from "./ObjectThree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports